import { InjectionToken, Signal } from '@angular/core';
import { SurfaceMode } from '../_shared/types/surface-mode.type';

/**
 * The surface mode of the nearest `sirius-section`, for components that must decide something in
 * code. Styling never needs it: the custom properties inherit.
 */
export interface SectionSurface {
    readonly surfaceMode: Signal<SurfaceMode | undefined>;
}

export const SECTION_SURFACE = new InjectionToken<SectionSurface>('SECTION_SURFACE');
